import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/modal';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import SearchSelector from 'components/fields/SearchSelector';
import { getCustomer, getCustomers } from 'interfaces/customer';
import {
    addBulkTransaction,
    addFullCreditNoteTransaction,
    addFullTooPerceiveTransaction,
    getNotPaidInvoicedPerCustomer,
} from 'interfaces/invoice';
import { useEffect, useState } from 'react';
import { MdInfo } from 'react-icons/md';

const defaultPaymentMethod =
    localStorage.getItem('defaultPaymentMethod-id') === null
        ? 'transfer'
        : localStorage.getItem('defaultPaymentMethod-id');
const defaultDate =
    localStorage.getItem('defaultPayementDate') === null
        ? new Date().toISOString().split('T')[0]
        : localStorage.getItem('defaultPayementDate');

console.log(`DefaultDate: ${defaultDate}`);
const EnterPayement = (props: { isOpen: any; onClose: any }) => {
    const { isOpen, onClose } = props;
    const [paymentMethod, setPaymentMethod] = useState(defaultPaymentMethod);
    const [transaction, setTransaction] = useState({
        transactions: [],
        date: defaultDate,
        totalPayed: 0,
        paymentMethod: defaultPaymentMethod,
        reference: '',
    });
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [invoices, setInvoices] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(500);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChanges = (e: any) => {
        const { id, value } = e.target;
        setTransaction((prev: any) => ({ ...prev, [id]: value }));
    };

    const handleGlobalAmountChange = (e: any) => {
        let totalAmount = parseFloat(e.target.value || '0');

        const updatedTransactions = transaction.transactions.map(
            (transac: any) => ({ ...transac }),
        );

        const payingQueue = updatedTransactions
            .filter((t: any) => t.leftToPay > 0)
            .reverse();

        for (const transac of payingQueue) {
            if (totalAmount <= 0) {
                transac.amount = 0;
                continue;
            }

            const amountToPay = Math.min(transac.leftToPay, totalAmount);
            transac.amount = parseFloat(amountToPay.toFixed(2));
            totalAmount -= amountToPay;
        }

        setTransaction((prev: any) => ({
            ...prev,
            transactions: updatedTransactions,
            totalPayed: parseFloat(e.target.value || '0'),
        }));
    };

    const paymentMethodOptions: Record<string, string> = {
        cash: 'Espèces',
        check: 'Chèque',
        transfer: 'Virement',
        'credit-card': 'Carte bancaire',
        'direct-debit': 'Prélèvement',
    };

    const initCustomers = async () => {
        const res = await getCustomers();
        if (res) setCustomers(res.data);
    };

    const initInvoices = async () => {
        if (!selectedCustomer) return;
        const res = await getNotPaidInvoicedPerCustomer(
            limit,
            page,
            selectedCustomer?._id,
        );
        if (res && res.data) {
            setInvoices(res.data.data);
            setPage(page);
            setLimit(limit);

            // Init transactions
            const transactions = res.data.data
                .filter((i: any) => i.leftToPay > 0)
                .map((invoice: any) => {
                    return {
                        invoiceId: invoice._id,
                        amount: 0,
                        leftToPay: invoice.leftToPay,
                    };
                });
            setTransaction({
                ...transaction,
                transactions,
                totalPayed: 0,
                paymentMethod: transaction.paymentMethod,
                reference: transaction.reference,
            });
        }
    };

    useEffect(() => {
        console.log(transaction);
    }, [transaction]);

    const updateInvoicePaidAmount = (e: any, invoice: any) => {
        const { value } = e.target;
        let transacs = transaction.transactions;

        const actualTransac = transacs.find(
            (transac: any) => transac.invoiceId === invoice._id,
        );
        if (actualTransac) {
            actualTransac.amount = value;
        } else {
            transacs.push({
                invoiceId: invoice._id,
                amount: value,
            });
        }
        setTransaction((prev: any) => ({ ...prev, transactions: transacs }));
    };

    const getTransValue = (invoiceId: string) => {
        const transac = transaction.transactions.find(
            (transac: any) => transac.invoiceId === invoiceId,
        );
        return transac;
    };

    const impactCreditNote = async (invoiceId: string) => {
        const res = await addFullCreditNoteTransaction(invoiceId);
        if (res && res.data) {
            initInvoices();
        }
    };

    const impactTooPerceive = async (invoiceId: string) => {
        const res = await addFullTooPerceiveTransaction(invoiceId);
        if (res && res.data) {
            initInvoices();
        }
    };

    useEffect(() => {
        console.log(`CHANGE DATE: ${transaction.date}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transaction.date]);

    const onClick = async () => {
        if (isSubmitting) return; // Prevent multiple clicks
        setIsSubmitting(true); // Disable the button

        const res = await addBulkTransaction(transaction);
        console.log(`Sending: ${transaction.date}`);
        if (res && res.data) {
            window.location.reload();
        }else {
        setIsSubmitting(false); // Re-enable the button on error
    }
    };

    const CreditNoteAmount = (props: { transactions: any }) => {
        const { transactions } = props;
        const totalCreditNote = transactions
            .filter((t: any) => t?.paymentMethod === 'credit-note')
            .reduce((acc: any, t: any) => acc + (t?.amount || 0), 0);

        if (totalCreditNote <= 0) return null;

        return (
            <p className="text-xs text-toola-500">
                {totalCreditNote.toFixed(2)}€ TTC d'avoir déjà imputés
            </p>
        );
    };

    const TooPerceiveAmount = (props: { transactions: any }) => {
        const { transactions } = props;
        const totalTooPerceive = transactions
            .filter((t: any) => t?.paymentMethod === 'too-perceive')
            .reduce((acc: any, t: any) => acc + (t?.amount || 0), 0);

        if (totalTooPerceive <= 0) return null;

        return (
            <p className="text-xs text-toola-500">
                {totalTooPerceive.toFixed(2)}€ TTC de trop perçu déjà imputés
            </p>
        );
    };

    const CreditNoteList = (props: { invoices: any }) => {
        const { invoices } = props;
        const [showAvoir, setShowAvoir] = useState(false);

        const filteredInvoices = invoices
            ?.filter(
                (i: any) => i.status === 'credit-note' && i.leftToPay !== 0,
            )
            .reverse();

        if (filteredInvoices.length === 0) return null;

        return (
            <>
                <div className="mb-2">
                    <div
                        className="flex items-center justify-between bg-green-100 px-4 py-2 rounded cursor-pointer"
                        onClick={() => setShowAvoir(!showAvoir)}
                    >
                        <p className="text-sm font-semibold">
                            {filteredInvoices
                                .reduce(
                                    (acc: any, i: any) => acc + i.leftToPay,
                                    0,
                                )
                                .toFixed(2)}
                            € d'avoirs imputables
                            <MdInfo
                                className="inline ml-1 cursor-help"
                                title="Une fois l'avoir imputé, il ne sera plus visible ici et sera déduit du restant à payer affiché sur vos factures."
                            />
                        </p>
                        <span className="text-xl">{showAvoir ? '−' : '+'}</span>
                    </div>

                    {showAvoir && (
                        <div className="grid grid-cols-1 gap-4 overflow-y-auto max-h-[200px] mt-2">
                            {filteredInvoices.map(
                                (invoice: any, index: number) => (
                                    <div className="flex items-center justify-between p-3 bg-gray-100 rounded-lg">
                                        <div>
                                            <p className="font-medium text-sm text-gray-700">
                                                Avoir #{invoice.invoiceNumber}
                                            </p>
                                            <p className="text-xs text-gray-600 font-bold">
                                                Disponible : {invoice.leftToPay}{' '}
                                                € TTC
                                            </p>
                                        </div>
                                        <div className="flex flex-col items-end">
                                            <button
                                                className="bg-toola-500 hover:bg-toola-600 text-white text-xs px-3 py-2 rounded-md"
                                                onClick={() =>
                                                    impactCreditNote(
                                                        invoice._id,
                                                    )
                                                }
                                            >
                                                Imputer {invoice.leftToPay} €
                                                sur mes factures
                                            </button>
                                        </div>
                                    </div>
                                ),
                            )}
                        </div>
                    )}
                </div>
            </>
        );
    };

    const TooPerceiveList = (props: { invoices: any }) => {
        const { invoices } = props;
        const [showAvoir, setShowAvoir] = useState(false);

        const filteredInvoices = invoices
            ?.filter((i: any) => i.status === 'paid' && i.leftToPay < 0)
            .reverse();

        if (filteredInvoices.length === 0) return null;

        return (
            <>
                <div className="mb-4">
                    <div
                        className="flex items-center justify-between bg-green-100 px-4 py-2 rounded cursor-pointer"
                        onClick={() => setShowAvoir(!showAvoir)}
                    >
                        <p className="text-sm font-semibold">
                            {filteredInvoices
                                .reduce(
                                    (acc: any, i: any) => acc + i.leftToPay,
                                    0,
                                )
                                .toFixed(2)}
                            € de trop perçu
                            <MdInfo
                                className="inline ml-1 cursor-help"
                                title="Une fois le trop perçu imputé, il ne sera plus visible ici et sera déduit du restant à payer affiché sur vos factures."
                            />
                        </p>
                        <span className="text-xl">{showAvoir ? '−' : '+'}</span>
                    </div>

                    {showAvoir && (
                        <div className="grid grid-cols-1 gap-3 overflow-y-auto max-h-[200px] mt-2">
                            {filteredInvoices.map(
                                (invoice: any, index: number) => (
                                    <div className="flex items-center justify-between p-3 bg-gray-100 rounded-lg">
                                        <div>
                                            <p className="font-medium text-sm text-gray-700">
                                                Facture #{invoice.invoiceNumber}
                                            </p>
                                            <p className="text-xs text-gray-600 font-bold">
                                                Trop perçu : {invoice.leftToPay}{' '}
                                                € TTC
                                            </p>
                                        </div>
                                        <div className="flex flex-col items-end">
                                            <button
                                                className="bg-toola-500 hover:bg-toola-600 text-white text-xs px-3 py-2 rounded-md"
                                                onClick={() =>
                                                    impactTooPerceive(
                                                        invoice._id,
                                                    )
                                                }
                                            >
                                                Imputer {invoice.leftToPay} €
                                                sur mes factures
                                            </button>
                                        </div>
                                    </div>
                                ),
                            )}
                        </div>
                    )}
                </div>
            </>
        );
    };

    useEffect(() => {
        initInvoices();
        if (selectedCustomer?._id) {
            getCustomer(selectedCustomer._id).then((customer) => {
                if (customer?.paymentMethod && paymentMethodOptions[customer.paymentMethod]) {
                    setPaymentMethod(customer.paymentMethod);
                    setTransaction((prev: any) => ({
                        ...prev,
                        paymentMethod: customer.paymentMethod,
                    }));
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCustomer]);

    useEffect(() => {
        initCustomers();
    }, []);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay className="bg-[#000] !opacity-30" />
            <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[90%] top-[5vh]">
                <ModalBody>
                    <Card extra="px-[30px] pt-[15px] pb-[40px] max-w-[850px] flex flex-col !z-[1004] overflow-y-auto max-h-[700px]">
                        <>
                            <h1 className="mb-2 text-xl font-medium">
                                Pointer un paiement
                            </h1>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                                <SearchSelector
                                    label="Client*"
                                    displayKey="company"
                                    value={selectedCustomer?._id}
                                    options={customers}
                                    onSelect={(e: any) => {
                                        setSelectedCustomer(e);
                                    }}
                                    inputSmall={true}
                                />
                                <InputField
                                    id="date"
                                    label="Date de paiement*"
                                    type="date"
                                    value={transaction?.date}
                                    inputSmall={true}
                                    onChange={(e: any) => {
                                        console.log(
                                            `Value changed to ${e.target.value}`,
                                        );
                                        handleChanges(e);
                                        localStorage.setItem(
                                            'defaultPayementDate',
                                            e.target.value,
                                        );
                                    }}
                                />
                                <SearchSelector
                                    label="Méthode de paiement"
                                    displayKey="name"
                                    value={paymentMethod}
                                    inputSmall={true}
                                    options={[
                                        {
                                            _id: 'cash',
                                            name: 'Espèces',
                                        },
                                        {
                                            _id: 'check',
                                            name: 'Chèque',
                                        },
                                        {
                                            _id: 'transfer',
                                            name: 'Virement',
                                        },
                                        {
                                            _id: 'credit-card',
                                            name: 'Carte bancaire',
                                        },
                                        {
                                            _id: 'direct-debit',
                                            name: 'Prélèvement',
                                        },
                                    ]}
                                    onSelect={(e: any) => {
                                        setTransaction({
                                            ...transaction,
                                            paymentMethod: e._id,
                                        });
                                        setPaymentMethod(e._id);
                                        localStorage.setItem(
                                            'defaultPaymentMethod-id',
                                            e._id,
                                        );
                                    }}
                                />
                                <InputField
                                    id="reference"
                                    label="Référence de paiement"
                                    type="text"
                                    placeholder="RF-2021-0001"
                                    inputSmall={true}
                                    value={transaction.reference}
                                    onChange={handleChanges}
                                />
                            </div>
                            <CreditNoteList invoices={invoices} />
                            <TooPerceiveList invoices={invoices} />
                            <InputField
                                id="totalPayed"
                                label="Montant payé*"
                                type="number"
                                value={transaction.totalPayed}
                                inputSmall={true}
                                onChange={handleGlobalAmountChange}
                            />
                            <div className="mt-2 flex items-center justify-between mb-3">
                                <p className="mt-2 mb-1 text-sm">N facture</p>
                                <div>
                                    <p className="mt-2 mb-1 text-sm">
                                        Reste à payer
                                    </p>
                                </div>
                                <p className="mt-2 mb-1 text-sm">
                                    Montant payé
                                </p>
                            </div>
                            {invoices && invoices.length > 0 && (
                                <>
                                    <div className="grid grid-cols-1 gap-3 overflow-y-auto max-h-[200px]">
                                        {invoices
                                            .filter(
                                                (i) =>
                                                    i.status !==
                                                        'credit-note' &&
                                                    i.leftToPay > 0,
                                            )
                                            .reverse()
                                            .map(
                                                (
                                                    invoice: any,
                                                    index: number,
                                                ) => (
                                                    <div
                                                        key={index}
                                                        className="flex items-center justify-between p-1 bg-gray-100/50 rounded-lg"
                                                    >
                                                        <div className="">
                                                            <p className="text-sm">
                                                                #
                                                                {
                                                                    invoice.invoiceNumber
                                                                }
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <p className="text-sm">
                                                                {
                                                                    invoice.leftToPay
                                                                }{' '}
                                                                € TTC
                                                            </p>
                                                            <CreditNoteAmount
                                                                transactions={
                                                                    invoice.transactions
                                                                }
                                                            />
                                                            <TooPerceiveAmount
                                                                transactions={
                                                                    invoice.transactions
                                                                }
                                                            />
                                                        </div>
                                                        <div className="flex">
                                                            <InputField
                                                                id={invoice._id}
                                                                type="number"
                                                                extra="w-[70px] text-right"
                                                                value={
                                                                    getTransValue(
                                                                        invoice._id,
                                                                    )
                                                                        ? getTransValue(
                                                                              invoice._id,
                                                                          )
                                                                              .amount
                                                                        : 0
                                                                }
                                                                inputSmall={
                                                                    true
                                                                }
                                                                disabled={
                                                                    invoice.status ===
                                                                    'credit-note'
                                                                }
                                                                onChange={(
                                                                    e: any,
                                                                ) =>
                                                                    updateInvoicePaidAmount(
                                                                        e,
                                                                        invoice,
                                                                    )
                                                                }
                                                            />
                                                            <p className="mx-1 mt-2.5">
                                                                €
                                                            </p>
                                                        </div>
                                                    </div>
                                                ),
                                            )}
                                    </div>
                                    <p className="mt-3 mb-1 text-base">
                                        <span className="font-bold text-toola-500">
                                            Reste à payer total:
                                        </span>{' '}
                                        {invoices && invoices.length > 0
                                            ? invoices
                                                  .filter(
                                                      (i) =>
                                                          (i.status !==
                                                              'credit-note' &&
                                                              i.leftToPay >
                                                                  0) ||
                                                          (i.status ===
                                                              'credit-note' &&
                                                              i.leftToPay !=
                                                                  0) ||
                                                          (i.status ===
                                                              'paid' &&
                                                              i.leftToPay < 0),
                                                  )
                                                  .reduce(
                                                      (acc, i) =>
                                                          acc + i.leftToPay,
                                                      0,
                                                  )
                                                  .toFixed(2)
                                            : 0}
                                        € TTC
                                    </p>
                                </>
                            )}
                        </>
                        <div className="mt-5 flex gap-2 mx-auto">
                            <button
                                onClick={onClose}
                                className="linear rounded-xl border-2 border-gray-700 px-5 py-3 text-base font-medium text-gray-700 transition duration-200 hover:bg-red-600/5 active:bg-red-700/5 dark:border-red-400 dark:bg-red-400/10 dark:text-white dark:hover:bg-red-300/10 dark:active:bg-red-200/10"
                            >
                                Annuler
                            </button>
                                                        <button
                                className={`linear hover:bg-toola-600 col-span-12 ml-3 flex items-center justify-center rounded-xl bg-toola-500 px-3 py-3 text-base font-medium text-white active:bg-toola-700 sm:col-span-6 lg:col-span-4 xl:col-span-3 xl:col-start-12 ${
                                    isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                }`}
                                onClick={onClick}
                                disabled={isSubmitting} // Désactive le bouton
                            >
                                {isSubmitting ? 'Traitement...' : 'Pointer le paiement'}
                            </button>
                        </div>
                    </Card>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default EnterPayement;
